import { Clipboard } from '@angular/cdk/clipboard';
import { Component, inject } from '@angular/core';
import {
    BaseCellRendererComponent,
    IDropDownItem,
    IconSize,
    IconTheme,
    TapestryNotificationService
} from '@predictiveindex/tapestry';
import { TranslationService } from '../../../../translations';
import { PlatformOpenInvitationService } from './openinvitation.api';

@Component({
    selector: 'oi-action-menu-renderer',
    template: `<tapestry-icon-button
            [matMenuTriggerFor]="menu.matMenu"
            iconName="ellipsis_bold"
            [iconSize]="IconSize.Medium"
            [iconTheme]="iconTheme"
            class="dropdown-button"
            style="color: black"
            isRoundButton="true"
        >
        </tapestry-icon-button
        ><tapestry-dropdown
            #menu
            [optionsList]="actionMenuDropDownItems"
            (menuOptionSelected)="menuAction($event)"
        ></tapestry-dropdown>`,
    styleUrls: ['./open-invitation.component.less'],
    standalone: false
})
export class OIActionMenuRendererComponent extends BaseCellRendererComponent {
    private TR = inject(TranslationService);

    actionMenuDropDownItems: IDropDownItem[] = [
        {
            id: 'copy-oi-link',
            title: this.TR.key('seller-tools.oi-link.copy-link'),
            icon: 'link'
        },
        {
            id: 'edit-oi-link',
            title: this.TR.key('seller-tools.oi-link.edit-link'),
            icon: 'pencil'
        },
        {
            id: 'delete-oi-link',
            title: this.TR.key('seller-tools.oi-link.delete-link'),
            icon: 'trash'
        }
    ];
    iconTheme = IconTheme.Dark;
    protected readonly IconSize = IconSize;

    constructor(
        private readonly clipboard: Clipboard,
        private readonly oiService: PlatformOpenInvitationService,
        private readonly tapestryNotification: TapestryNotificationService
    ) {
        super();
    }

    async menuAction(id: string): Promise<void> {
        switch (id) {
            case 'copy-oi-link': {
                this.clipboard.copy(this.params.url);
                this.tapestryNotification.create({
                    message: 'Open Invitation Link copied to your clipboard',
                    type: 'success',
                    duration: 3000
                });
                break;
            }
            case 'edit-oi-link': {
                this.oiService.editLink.next(this.params.data);
                break;
            }
            case 'delete-oi-link': {
                this.tapestryNotification.create({
                    message: 'Deleting link',
                    type: 'processing'
                });
                try {
                    await this.oiService.deleteOiLink(this.params.id);
                } catch (e) {
                    this.tapestryNotification.create({
                        message: 'Error deleting this link',
                        type: 'error'
                    });
                } finally {
                    this.tapestryNotification.create({
                        message: 'Link deleted',
                        type: 'success',
                        duration: 3000
                    });
                }
                break;
            }
            default:
                break;
        }
    }
}
